import { TipoRegistroInstrumentoFinanceiro } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { CadastroMovimentacaoAction, cadastroMovimentacaoInitialState, CadastroMovimentacaoState } from './cadastroMovimentacao';

interface IStateCadastroMovimentacao {
  cadastroMovimentacao: CadastroMovimentacaoState;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('cadastroMovimentacao/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('cadastroMovimentacao/HIGHLIGHT_ERRORS', payload);
};

export function novoCadastroMovimentacaoReducer(
  state: IStateCadastroMovimentacao = {
    cadastroMovimentacao: cadastroMovimentacaoInitialState,
  },
  action: CadastroMovimentacaoAction
): IStateCadastroMovimentacao {
  switch (action.type) {
    case 'cadastroMovimentacao/UPDATEFIELD':
      return { ...state, cadastroMovimentacao: { ...state.cadastroMovimentacao, [action.payload.name]: action.payload.value } };
    case 'cadastroMovimentacao/UPDATE':
      return { ...state, cadastroMovimentacao: action.payload };
    case 'cadastroMovimentacao/RESET':
      return { ...state, cadastroMovimentacao: cadastroMovimentacaoInitialState };
    default:
      return state;
  }
}


export default novoCadastroMovimentacaoReducer;
